import { LogManager } from '../log/log.manager';
import { LogCat } from '../log/log.categories';
import * as i0 from "@angular/core";
import * as i1 from "../http-helpers/http.wrapper";
/**
 ****************************************************************
 * Proxy service class for asset calls.
 *
 * Created by Shai Zelman on 03/05/2020.
 ****************************************************************
 */
var AssetsProxy = /** @class */ (function () {
    function AssetsProxy(httpWrapper) {
        this.httpWrapper = httpWrapper;
    }
    AssetsProxy.prototype.getStaticAssetByCode = function (code) {
        LogManager.debug(LogCat.Asset.Proxy, "Get static asset by code.", code);
        return this.httpWrapper.getBlob("StaticAsset", "GetStaticAssetByCode", { pName: "code", pVal: code }, null, true, true);
    };
    AssetsProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AssetsProxy_Factory() { return new AssetsProxy(i0.ɵɵinject(i1.HttpWrapper)); }, token: AssetsProxy, providedIn: "root" });
    return AssetsProxy;
}());
export { AssetsProxy };
